export const useSiteConfig = () => {

  const contactPhone = "+48 22 103 39 74";
  const homePageContactPhone = "+48 32 308 84 44"
  const contactPhoneSec = "+48 22 104 92 05";
  const rpContactPhone = "+48 729 087 800"
  const moyaContactPhone = "+48 732 096 518"
  const bokPhone = "+48 32 308 84 44";
  const contactEmail = "bok@vehis.pl";
  const customerServicePhone = "+48 32 308 84 44";

  const workingHours = {
    start: "9:00",
    end: "20:00"
  }

  const homePageworkingHours = {
    start: "9:00",
    end: "20:00"
  }

  const customerServiceWorkingHours = {
    start: "8:00",
    end: "17:00"
  }

  const homeContact = {
    phone: contactPhone,
    workingHours: homePageworkingHours
  }

  return {
    contactPhone,
    homePageContactPhone,
    contactPhoneSec,
    rpContactPhone,
    contactEmail,
    workingHours,
    homePageworkingHours,
    homeContact,
    bokPhone,
    moyaContactPhone,
    customerServicePhone,
    customerServiceWorkingHours
  }
}
